
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M28.82 7.344H8.916l.321 17.496 17.123 17.333h10.75V15.637H28.82z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M13.892 20.714V2.368h19.073l9.122 9.122v25.707H26.973"}}),_c('path',{attrs:{"stroke":"#234652","d":"M30.86 2.937v8.989h8.989"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M5.57 45.631h19.568L5.57 26.063z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M9.428 25.55v15.9h15.9M23.915 26.674 9.671 41.172M28.5 18.5v5h-3v-1.538"}})])
          )
        }
      }
    